class ImageLoader {
    constructor(el) {

        // store for later
        this.el = el;

        // add listeners etc
        if (this.el.complete) {
            this.hasLoaded();
        } else {
            let _this = this;
            this.el.addEventListener('load', () => {
                _this.hasLoaded();
            }, {once: true});
        }
    }

    hasLoaded() {
        this.el.classList.add('loaded');
    }
}

// export the default function to create
export function createFrom(wrappers) {
    wrappers.forEach((node) => {
        // if node is an element
        if (node.nodeType === 1) {
            new ImageLoader(node);
        }
    });
}